import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-unit-details-header-controls',
  templateUrl: './unit-details-header-controls.component.html',
  styleUrls: ['./unit-details-header-controls.component.scss'],
})
export class UnitDetailsHeaderControlsComponent {
  @Output() month_change: EventEmitter<number> = new EventEmitter<number>();
  @Output() year_change: EventEmitter<number> = new EventEmitter<number>();
}
